/**
 * Sentry init for the ParleyRide web app.
 *
 * No-ops when VITE_SENTRY_DSN is unset or @sentry/react is not installed.
 * Once you `bun add @sentry/react`, the init runs on app boot.
 */

let initialized = false;

export async function initSentry(): Promise<void> {
  if (initialized) return;
  initialized = true;

  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      environment:
        (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
        import.meta.env.MODE,
      release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch {
    // @sentry/react not installed yet — silently skip.
  }
}
